jQuery(function($){
    if ($('.rotate-words').length == 0){
        return;
    }

    var $words = $(".rotate-words span");
    var currentIndex = 0;
    var maxWidth = 0;

    $words.each(function(){
        if ($(this).width() > maxWidth){
            maxWidth = $(this).width();
        }
    });

    $('.rotate-words').css('width', maxWidth + 'px');

    function rotateWords() {
        $words.eq(currentIndex).removeClass("active").addClass("previous");

        currentIndex = (currentIndex + 1) % $words.length;

        $words.eq(currentIndex).addClass("active");

        setTimeout(function () {
            $words.eq(currentIndex - 1 < 0 ? $words.length - 1 : currentIndex - 1).removeClass("previous");
        }, 500); 
    }

    $words.eq(currentIndex).addClass("active");

    setInterval(rotateWords, 3000);
});